import React, { useState } from 'react';
import { useTheme, themes } from '../contexts/ThemeContext';
import { Palette, Check, X } from 'lucide-react';

export const ThemeSelector = () => {
  const { currentTheme, setTheme, theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          p-2 rounded-lg transition-all duration-200
          ${theme.colors.bgTertiary} ${theme.colors.border} border
          ${theme.colors.textSecondary} hover:${theme.colors.textPrimary}
          hover:scale-105
        `}
        title="Changer le thème"
        data-testid="theme-selector-toggle"
      >
        <Palette size={20} />
      </button>

      {/* Dropdown Panel */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Theme Panel - positioned below sidebar header */}
          <div 
            className={`
              fixed left-4 top-24 z-50 w-56
              ${theme.colors.bgSecondary} ${theme.colors.border} border
              rounded-xl shadow-2xl overflow-hidden
              animate-in fade-in slide-in-from-top-2 duration-200
            `}
          >
            {/* Header */}
            <div className={`px-3 py-2 ${theme.colors.bgTertiary} border-b ${theme.colors.border} flex items-center justify-between`}>
              <span className={`font-medium text-sm ${theme.colors.textPrimary}`}>
                Apparence
              </span>
              <button 
                onClick={() => setIsOpen(false)}
                className={`p-1 rounded ${theme.colors.bgHover} ${theme.colors.textMuted}`}
              >
                <X size={14} />
              </button>
            </div>

            {/* Theme Options */}
            <div className="p-1.5 space-y-0.5 max-h-80 overflow-y-auto">
              {Object.values(themes).map((t) => (
                <button
                  key={t.id}
                  onClick={() => {
                    setTheme(t.id);
                    setIsOpen(false);
                  }}
                  className={`
                    w-full flex items-center gap-2 p-2 rounded-lg transition-all duration-200
                    ${currentTheme === t.id 
                      ? `${theme.colors.sidebarActive} ring-1 ring-current` 
                      : `${theme.colors.bgHover} ${theme.colors.textSecondary}`
                    }
                  `}
                  data-testid={`theme-option-${t.id}`}
                >
                  {/* Theme Preview */}
                  <div 
                    className="w-8 h-8 rounded-lg flex items-center justify-center text-sm shadow-inner flex-shrink-0"
                    style={{ 
                      backgroundColor: t.colors.cssVars['--bg-primary'],
                      border: `2px solid ${t.colors.cssVars['--border']}`
                    }}
                  >
                    {t.icon}
                  </div>
                  
                  {/* Theme Info */}
                  <div className="flex-1 text-left min-w-0">
                    <div className={`text-sm font-medium truncate ${currentTheme === t.id ? theme.colors.textAccent : theme.colors.textPrimary}`}>
                      {t.name}
                    </div>
                    <div className={`text-xs truncate ${theme.colors.textMuted}`}>
                      {t.description}
                    </div>
                  </div>

                  {/* Check Icon */}
                  {currentTheme === t.id && (
                    <Check size={16} className={`${theme.colors.textAccent} flex-shrink-0`} />
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ThemeSelector;
